import { forwardRef } from "react";

import { Paragraph } from "@/components/atoms/Paragraph";
import { reviewStatusVariants } from "@/components/atoms/ReviewStatus/constants";
import type { IReviewStatusProps } from "@/components/atoms/ReviewStatus/types";
import cn from "@/helpers/cn";
import { useTranslations } from "@/hooks/common/useTranslations";

const ReviewStatus = forwardRef<HTMLDivElement, IReviewStatusProps>(
  ({ type, className, ...props }, ref) => {
    const { t } = useTranslations("SingleAppPage");
    const text = t(
      type === "helpful" ? "mostHelpfulReview" : "notHelpfulReview",
    );

    return (
      <div className="flex items-center gap-2">
        <div
          className={cn(reviewStatusVariants({ type, className }))}
          ref={ref}
          {...props}
        >
          <Paragraph size="extraSmall" fontWeight="regular">
            {text}
          </Paragraph>
        </div>
      </div>
    );
  },
);

ReviewStatus.displayName = "ReviewStatus";

export default ReviewStatus;
